import { Component, OnInit } from '@angular/core';
import { AdmihairBaseComponent } from '../../admihair-base.component';
import { Orcamento } from 'src/app/admihair/api/dto/orcamento';
import { ItemOrcamento } from 'src/app/admihair/api/dto/item-orcamento';
import { OrcamentoService } from 'src/app/admihair/service/orcamento.service';
import { ActivatedRoute } from '@angular/router';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-resgate-pacote-janela',
  templateUrl: './resgate-pacote-janela.component.html',
  styleUrls: ['./resgate-pacote-janela.component.scss']
})
export class ResgatePacoteJanelaComponent extends AdmihairBaseComponent implements OnInit {

  id?: number;
  orcamento?: Orcamento;
  itensOrcamento: ItemOrcamento[] = [];
  loading: boolean = true;
  loadingPacote: boolean = false;


  constructor(
    private orcamentoService: OrcamentoService,
    private _activatedRoute: ActivatedRoute,
    erroService: ErroService,
    storageService: UtilStorageService) {
    super(erroService, storageService);
  }

  ngOnInit(): void {
    this.carregarIdOrcamento();
    this.carregarOrcamento();
  }

  carregarIdOrcamento() {
    const idParam = this._activatedRoute.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
    }
  }

  carregarOrcamento() {
    console.log(this.id)
    this.orcamentoService.buscarPorTransferenciaId(this.id).subscribe({
      next: (data: Orcamento) => {
        this.orcamento = data;
        this.itensOrcamento = data.listaItens ?? [];
        this.setExibirSpinnerPrincipal(false);
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })
  }

  calcularValorAResgatar(item: ItemOrcamento) {
    const descontoGeral = this.orcamento?.desconto ?? 0;

    const saldoQuantidade = (item.quantidadeProposta ?? 0) - (item.quantidadeEntregue ?? 0);
    const totalSemDesconto = (item.valorUnitario ?? 0) * saldoQuantidade;

    const valorTotalItem = totalSemDesconto - (totalSemDesconto * (item.descontoItem ?? 0) / 100);
    const valorAResgatarItem = valorTotalItem - (valorTotalItem * descontoGeral / 100);

    return valorAResgatarItem;

  }

}
